module.exports = __webpack_public_path__ + "static/media/img3.6db9cc56.jpg";